<template>
  <div class="about-us-page">

    <about-us-hero-section
      :fields="aboutUsPageSections.sections.about_us_hero_section.fields"
    />

    <about-us-divider-section
      :fields="aboutUsPageSections.sections.about_us_divider_section.fields"
    />

    <about-us-cover-section
      :fields="aboutUsPageSections.sections.about_us_cover_section.fields"
    />

    <about-us-text-section
      :fields="aboutUsPageSections.sections.about_us_text_section.fields"
    />

    <about-us-divider2-section
      :fields="aboutUsPageSections.sections.about_us_divider2_section.fields"
    />

    <about-us-text2-section
      :fields="aboutUsPageSections.sections.about_us_text2_section.fields"
    />

    <about-us-slider-section
      :fields="aboutUsPageSections.sections.about_us_slider_section.fields"
    />

    <about-us-divider3-section
      :fields="aboutUsPageSections.sections.about_us_divider3_section.fields"
    />

    <about-us-team-section
      :fields="aboutUsPageSections.sections.about_us_team_section.fields"
    />

    <about-us-divider4-section
      :fields="aboutUsPageSections.sections.about_us_divider4_section.fields"
    />

    <about-us-members-section
      :fields="aboutUsPageSections.sections.about_us_members_section.fields"
    />

  </div>
</template>

<script>

import DividerSection from "/seu-frontend/sections/general/DividerSection";
import AboutUsHeroSection from "/seu-frontend/sections/about-us-page/AboutUsHeroSection";
import AboutUsCoverSection from "/seu-frontend/sections/about-us-page/AboutUsCoverSection";
import AboutUsTextSection from "/seu-frontend/sections/about-us-page/AboutUsTextSection";
import AboutUsText2Section from "/seu-frontend/sections/about-us-page/AboutUsText2Section";
import AboutUsText3Section from "/seu-frontend/sections/about-us-page/AboutUsText3Section";
import AboutUsTeamSection from "/seu-frontend/sections/about-us-page/AboutUsTeamSection";
import AboutUsMembersSection from "/seu-frontend/sections/about-us-page/AboutUsMembersSection";
import AboutUsSliderSection from "/seu-frontend/sections/about-us-page/AboutUsSliderSection";
import AboutUsDividerSection from "/seu-frontend/sections/about-us-page/AboutUsDividerSection";
import AboutUsDivider2Section from "/seu-frontend/sections/about-us-page/AboutUsDivider2Section";
import AboutUsDivider3Section from "/seu-frontend/sections/about-us-page/AboutUsDivider3Section";
import AboutUsDivider4Section from "/seu-frontend/sections/about-us-page/AboutUsDivider4Section";

export default {
  name: "AboutUsPage",
  components: {
    AboutUsDivider4Section,
    AboutUsDivider3Section,
    AboutUsDivider2Section,
    AboutUsDividerSection,
    AboutUsSliderSection,
    AboutUsMembersSection,
    AboutUsTeamSection,
    AboutUsText3Section,
    AboutUsText2Section,
    AboutUsTextSection,
    AboutUsCoverSection,
    AboutUsHeroSection,
    DividerSection,
  },
  computed: {
    aboutUsPageSections() {
      return require(`../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/aboutUsPage`).default;
    }
  },
  metaInfo() {
    return {
      title: this.aboutUsPageSections.title,
    }
  }

}
</script>

<style lang="scss">
@import "AboutUsPage.scss";
</style>
